import { Resolve, RouterStateSnapshot, ActivatedRouteSnapshot } from "@angular/router";
import { CounsellingTopicVM, WhoAmIVM } from "../models";
import { Injectable } from "@angular/core";
import { ReferenceDataService } from "../services/referencedata.service";
import { AuthService } from "../services/auth.service";

@Injectable()
export class WhoAmIResolve implements Resolve<WhoAmIVM> {

    constructor(private authService: AuthService) {

    }

    resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
        return new Promise<WhoAmIVM>((resolve, reject) => {
            this.authService.whoAmI(false).subscribe(
                (data) => {
                    if (data.username == null) {
                        localStorage.removeItem('authToken');
                        location.reload();
                    }
                    resolve(data);
                },
                error => {
                    localStorage.removeItem('authToken');
                    location.reload();
                }
            );
        }).then(function (data) {
            return data;
        });
    }

}
